/* RESPONSIBLE TEAM: team-ml */
// Trigger experimental Ember build for Data page
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentDataRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentDataRoute);
